import React, {ElementType, ReactNode} from 'react';

import Heading from '../../../atoms/Heading/Heading.react';

export interface Props {
  as?: ElementType;
  children: ReactNode;
}

export const Title = ({as, children, ...rest}: Props) => (
  <Heading className='o-wall-title' as={as} {...rest}>
    {children}
  </Heading>
);
